import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { TimbroamStateProvider } from "./lib/appState";
import "./styles/global.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
      <TimbroamStateProvider>
        <App />
      </TimbroamStateProvider>
    </BrowserRouter>
  </React.StrictMode>
);
